import routerOptions0 from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher_e50bcd92f9fdbb4bc71ed87e93b8b1c9/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}